import { RegaliaUxConstants } from '../constants';

export const getSmartHref = (value) => {
    if (!value) return

    const trimmed = value.trim();
    const { REGEX } = RegaliaUxConstants;

    if (REGEX.EMAIL.test(trimmed)) return `mailto:${trimmed}`;
    if (REGEX.URL.test(trimmed)) return trimmed.startsWith('http')
        ? trimmed
        : `https://${trimmed}`;

    return
};